var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.377,
    height: 13.777,
    viewBox: "0 0 16.377 13.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3.629,17.085a.627.627,0,0,0,.5-.246l.274-.356a6.887,6.887,0,0,0,12.525,2.661.63.63,0,0,0-1.051-.7,5.624,5.624,0,0,1-10.247-2.29l.539.415a.63.63,0,0,0,.768-1L5.445,14.427c-.313-.241-.758-.377-1.042-.007L3.131,16.072a.629.629,0,0,0,.5,1.013Z",
    transform: "translate(-3 -8.442)",
    fill: "#546c7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M7,9.011a.631.631,0,0,0,.874-.177,5.624,5.624,0,0,1,10.247,2.29l-.539-.415a.63.63,0,0,0-.768,1l1.493,1.149c.319.245.754.382,1.042.007l1.272-1.652a.629.629,0,1,0-1-.768l-.274.356A6.888,6.888,0,0,0,6.826,8.138.631.631,0,0,0,7,9.011Z",
    transform: "translate(-4.378 -5.063)",
    fill: "#546c7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b009ba4d141abe0c012dd41e6788ee4c.svg";
export { ForwardRef as ReactComponent };